/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseNoteConversation } from '../../models/api-response-note-conversation';
import { NoteConversation } from '../../models/note-conversation';

export interface CreateNoteConversation$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: NoteConversation
}

export function createNoteConversation(http: HttpClient, rootUrl: string, params: CreateNoteConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseNoteConversation>> {
  const rb = new RequestBuilder(rootUrl, createNoteConversation.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseNoteConversation>;
    })
  );
}

createNoteConversation.PATH = '/v1/api/ui/note-conversation';
